import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'
import { connect } from 'react-redux'

import {
    helpers,
    sendClickSoundCommand,
    sendHoverSoundCommand,
} from 'react-wot-bootstrap'

import { toRoman } from 'helpers'
import { isVehicleReadyForBattle } from 'helpers/vehicles'

import VehicleType from 'components/VehicleType/VehicleType'
import Nation from 'components/Nation/Nation'
import { VehiclePropTypes } from 'containers/BattleRooms/propTypes'

import { REMOVE_VEHICLE_TOOLTIP, VEHICLE_NOT_READY } from './constants'

import styles from './Vehicle.scss'

export const Vehicle = props => {
    const baseClasses = classNames(styles.base, {
        [styles['base__cn']]: helpers.isChineseRealm(props.realm),
    })

    const bonusClasses = classNames(styles.bonus, styles[`bonus__x${props.vehicle.dailyXPFactor}`])

    const isReady = isVehicleReadyForBattle(props.vehicle)

    return (
        <div className={baseClasses} >
            <div className={styles.vehicleImage} style={{ backgroundImage: `url(${props.vehicle.iconUrl})` }}/>
            <div className={bonusClasses} />
            {!isReady && <span className={styles.notReady}>{VEHICLE_NOT_READY}</span>}
            <footer className={styles.footer}>
                <div className={styles.nation}>
                    <Nation nation={props.vehicle.nation} realm={props.realm}/>
                </div>
                &nbsp;
                <VehicleType
                    mini
                    type={props.vehicle.type}
                    premium={props.vehicle.isPremium}
                />
                &nbsp;
                {toRoman(props.vehicle.level)}
                &nbsp;
                <span className={classNames(styles.name, { [styles.isPremium]: props.vehicle.isPremium })}>
                    {props.vehicle.shortName}
                </span>
            </footer>

            <button
                className={styles.closeButton}
                onClick={props.onClose}
                onMouseDown={sendClickSoundCommand}
                onMouseEnter={sendHoverSoundCommand}
                data-tip data-for={REMOVE_VEHICLE_TOOLTIP.id}
            />
        </div>
    )
}

Vehicle.propTypes = {
    onClose: PropTypes.func.isRequired,
    vehicle: VehiclePropTypes,
    realm: PropTypes.string.isRequired,
}

const mapStateToProps = state => ({
    realm: state.settings.realm,
})

export default connect(mapStateToProps)(Vehicle)



// WEBPACK FOOTER //
// ./containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/Vehicle.jsx